import * as React from 'react'

interface Props {
  onClickAway?: (e?: any) => void
  children: React.ReactElement
}

export const ClickAwayListener = ({ onClickAway, children }: Props) => {
  const [clickedAway, setClickedAway] = React.useState(false)
  const ref = React.useRef<HTMLElement | null>(null)

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setClickedAway(true)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])

  React.useEffect(() => {
    if (clickedAway && onClickAway) {
      onClickAway()
    }
    setClickedAway(false)
  }, [clickedAway, onClickAway])

  return React.cloneElement(children, { ref })
}
